import { render, staticRenderFns } from "./ReorderList.vue?vue&type=template&id=9a595c16&scoped=true&"
import script from "./ReorderList.vue?vue&type=script&lang=js&"
export * from "./ReorderList.vue?vue&type=script&lang=js&"
import style0 from "./ReorderList.vue?vue&type=style&index=0&id=9a595c16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a595c16",
  null
  
)

export default component.exports